import React, { ReactElement } from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import Dropdown from 'atomic/dropdown/dropdown';

interface SelectControlledProps {
    name: string;
    defaultValue?: string;
    list: { label: string; value: string; isDisabled?: boolean; className?: string; }[];
    label?: string;
    placeholder?: string;
    className?: string;
    hideSelectedItems?: boolean;
    isTransparent?: boolean;
    isHideTitle?: boolean;
    icon?: string;
    iconColor?: 'primary' | 'secondary' | 'third' | 'fourth' | 'white' | 'dark' | 'gray' | 'danger';
    error?: FieldError;
    control: Control;
    rules?: Record<string, number | string>;
}

const SelectControlled: React.FC<SelectControlledProps> = ({
    name,
    list,
    className,
    label,
    placeholder,
    defaultValue,
    hideSelectedItems,
    isTransparent,
    isHideTitle,
    icon,
    iconColor,
    control,
    rules,
    error
}) => {
    return (
        <Controller
            render={({ field: { onChange, value } }): ReactElement =>
                <Dropdown
                    list={list}
                    defaultValue={value}
                    onChange={onChange}
                    className={className}
                    label={label}
                    placeholder={placeholder}
                    hideSelectedItems={hideSelectedItems}
                    isTransparent={isTransparent}
                    isHideTitle={isHideTitle}
                    icon={icon}
                    iconColor={iconColor}
                    error={error}
                />}
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
        />
    );
};

export default SelectControlled;
